import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { STATIC_IMAGES } from '../../../app.config.vars/staticImages';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
const SyncInProgress = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content sync-in-progress', children: [_jsx("div", { className: "modal-content-icon", children: _jsx("img", { src: localStorage.getItem(STATIC_IMAGES.syncData.key) || undefined, alt: "sync in progress" }) }), _jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('sync_in_progress_please_wait'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: t('button.ok'), onClick: () => {
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                    } }) })] }));
};
export default SyncInProgress;
